


























































































import { Vue, Component } from 'vue-property-decorator';
import { Tabs, Tab, Sticky, List } from 'vant';
import {
  getVoteNumTotal,
  getHomeSchoolList,
  fetchAds,
  compositionList,
} from '../api';
import SearchBar from '@/components/next/SearchBar.vue';
Vue.use(Tabs)
  .use(Tab)
  .use(Sticky)
  .use(List);
@Component({
  components: {
    SearchBar,
  },
})
export default class Home extends Vue {
  keyword = '';
  activeTab = 0;
  ads = [];
  tabs = [
    {
      title: '参赛学校',
      id: 1,
    },
    {
      title: '参赛区县',
      id: 2,
    },
    // {
    //   title: '参赛作品',
    //   id: 1,
    // },
    {
      title: '初赛入围',
      id: 2,
    },
    {
      title: '决赛入围',
      id: 3,
    },
  ];
  voteNumTotal = 0;
  list: any[] = [
    {
      page: 1,
      id: 1,
      loading: false,
      finished: false,
      data: [],
    },
    {
      page: 1,
      id: 2,
      loading: false,
      finished: false,
      data: [],
    },
    {
      page: 1,
      id: 1,
      loading: false,
      finished: false,
      data: [],
    },
    { page: 1, id: 2, loading: false, finished: false, data: [] },
    { page: 1, id: 3, loading: false, finished: false, data: [] },
  ];

  async created() {
    const ret = await getVoteNumTotal();
    this.voteNumTotal = ret.data;
    this.getAds();
  }

  async onGetHomeList() {
    const targetData = this.list[this.activeTab];
    if (targetData.finished) {
      return console.log('no more data');
    }
    targetData.loading = true;
    let ret: any;
    try {
      if (this.activeTab === 0 || this.activeTab === 1) {
        // 学校，区县列表
        ret = await getHomeSchoolList({
          page: targetData.page,
          type: targetData.id,
        });
      } else {
        // 作文列表
        ret = await compositionList({
          page: targetData.page,
          workType: this.tabs[this.activeTab].id,
        });
      }
      targetData.loading = false;
      if (ret.data.length) {
        targetData.page++,
          (targetData.data = [...targetData.data, ...ret.data]);
      } else {
        targetData.finished = true;
      }
      // 隐藏学校id 3281 3415
      if (this.activeTab === 0) {
        targetData.data = targetData.data.filter(
          (item: any) => +item.school !== 3281 && +item.school !== 3415,
        );
      }
    } catch (error) {
      targetData.finished = true;
      console.log(error);
    }
  }

  onSearch() {
    this.$router.push(
      `search?keyword=${this.keyword}&workType=${
        this.tabs[this.activeTab].id
      }&index=${this.activeTab}`,
    );
  }

  onClear() {
    console.log('ready to clear');
  }
  onNavToDetail(data: any) {
    if (![0, 1].includes(this.activeTab)) {
      this.$router.push(`detail?id=${data.id}`);
    }
  }
  async getAds() {
    const ret = await fetchAds(1);
    this.ads = ret.data;
  }
  jumpToAdPage(url: string) {
    location.href = url;
  }
  playVideo() {
    location.href =
      'https://wap.cqcb.com/shangyou_news/NewsDetail?classId=3562&newsId=4021825';
  }
}
